import { useLanguage } from '../contexts/LanguageContext';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { SEOHead } from '../components/SEOHead';
import { BookOpen, Target, Users, Award } from 'lucide-react';

export default function MethodologyPage() {
  const { language } = useLanguage();

  return (
    <div className="min-h-screen bg-white">
      <SEOHead />
      <Navbar />
      <main className="pt-28 pb-20">
        <div className="max-w-4xl mx-auto px-6">
          <h1 className="text-4xl sm:text-5xl font-bold text-[#1D1D1F] mb-6" data-testid="methodology-title">
            {language === 'es' ? 'Metodología' : 'Methodology'}
          </h1>
          <p className="text-lg text-[#86868B] mb-12 max-w-2xl">
            {language === 'es'
              ? 'Seguimos el currículo oficial del Ministerio de Educación de España, adaptado para estudiantes internacionales.'
              : 'We follow the official curriculum of Spain\'s Ministry of Education, adapted for international students.'}
          </p>

          <div className="grid gap-8">
            {[
              {
                icon: <BookOpen className="h-6 w-6" />,
                title: language === 'es' ? 'Currículo Español Oficial' : 'Official Spanish Curriculum',
                desc: language === 'es'
                  ? 'Nuestro programa sigue las directrices del Ministerio de Educación de España. Los alumnos siguen el mismo itinerario que los estudiantes en España, adaptado a su contexto internacional.'
                  : 'Our program follows the guidelines of Spain\'s Ministry of Education. Students follow the same pathway as students in Spain, adapted to their international context.'
              },
              {
                icon: <Target className="h-6 w-6" />,
                title: language === 'es' ? 'Aprendizaje por Competencias' : 'Competency-Based Learning',
                desc: language === 'es'
                  ? 'Cada trimestre evalúa competencias lingüísticas específicas: comprensión oral, expresión escrita, lectura y conversación. Los alumnos progresan a su ritmo.'
                  : 'Each trimester evaluates specific language competencies: listening comprehension, written expression, reading, and conversation. Students progress at their own pace.'
              },
              {
                icon: <Users className="h-6 w-6" />,
                title: language === 'es' ? 'Grupos Reducidos' : 'Small Groups',
                desc: language === 'es'
                  ? 'Máximo 8 alumnos por grupo. Esto permite una atención personalizada y una participación activa de cada estudiante durante las sesiones de 50 minutos.'
                  : 'Maximum 8 students per group. This allows personalized attention and active participation from every student during 50-minute sessions.'
              },
              {
                icon: <Award className="h-6 w-6" />,
                title: language === 'es' ? 'Preparación DELE' : 'DELE Preparation',
                desc: language === 'es'
                  ? 'Para los niveles avanzados, preparamos a los alumnos para los exámenes oficiales DELE del Instituto Cervantes, reconocidos internacionalmente.'
                  : 'For advanced levels, we prepare students for the official DELE exams from Instituto Cervantes, internationally recognized.'
              },
            ].map((item, i) => (
              <div key={i} className="flex gap-5 p-6 bg-[#F5F5F7] rounded-2xl">
                <div className="w-12 h-12 rounded-xl bg-[#E63946]/10 flex items-center justify-center text-[#E63946] shrink-0">{item.icon}</div>
                <div>
                  <h3 className="text-lg font-semibold text-[#1D1D1F] mb-2">{item.title}</h3>
                  <p className="text-[#86868B] leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
